<template>
  <div>
    <div style="font-size: 35px;font-weight: bold;text-align: center">{{form1.title}}</div>
    <el-form  class="demo-ruleForm"  :model="form1"   ref="form1" style="min-height: 700px;width: 800px;margin: 0 auto;font-size: 18px">
      <div  class="gradeX" >
        <el-divider></el-divider>
        <div class="">来源:{{form1.source}}</div>
        <el-divider></el-divider>
        <div class="">关键字:{{form1.summary}}</div>
        <el-divider></el-divider>
        <div v-html='form1.content' class="">{{form1.content}}</div>
        <div class="" style="float: right">{{form1.updateDate}}</div>
      </div>
    </el-form>

  </div>
</template>

<script>
import rootPathssb from '@/api/mainApi'
import { dataGetUrl } from '@/api/index'
export default {
  name: 'admininformationpreview',
  data () {
    return {
      form1: {
        title: '',
        source: '',
        content: '',
        createTime: '',
        summary: '',
        state: '',
        updateDate: ''
      }
    }
  },
  created () {
    var that = this
    /* 获取父页面参数 */

    /* 后台申请默认值 */
    dataGetUrl(rootPathssb.rootPath + '/admini/news/find?id=' + that.$route.query.pid).then(function (response) {
      if (response.data.result === 1) {
        console.log('cg')
        that.form1 = response.data.object
      };

      console.log(response.data)
    }).catch(function (error) {
      console.log(error); console.log('aaa')
    })
  }
}
</script>

<style scoped>
  .dateleft input{

    text-indent: 2em !important;
  }
  .body1{
    width:1000px;
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/admininformationpreview.vue